var map = {
	"./Icon_add.svg": "./src/assets/svg/Icon_add.svg",
	"./Icon_analytics.svg": "./src/assets/svg/Icon_analytics.svg",
	"./Icon_arrow_down.svg": "./src/assets/svg/Icon_arrow_down.svg",
	"./Icon_arrow_right_white.svg": "./src/assets/svg/Icon_arrow_right_white.svg",
	"./Icon_audio.svg": "./src/assets/svg/Icon_audio.svg",
	"./Icon_back.svg": "./src/assets/svg/Icon_back.svg",
	"./Icon_calendar.svg": "./src/assets/svg/Icon_calendar.svg",
	"./Icon_check.svg": "./src/assets/svg/Icon_check.svg",
	"./Icon_checkbox.svg": "./src/assets/svg/Icon_checkbox.svg",
	"./Icon_conferences.svg": "./src/assets/svg/Icon_conferences.svg",
	"./Icon_console.svg": "./src/assets/svg/Icon_console.svg",
	"./Icon_delete.svg": "./src/assets/svg/Icon_delete.svg",
	"./Icon_diagnostics.svg": "./src/assets/svg/Icon_diagnostics.svg",
	"./Icon_disable.svg": "./src/assets/svg/Icon_disable.svg",
	"./Icon_edit.svg": "./src/assets/svg/Icon_edit.svg",
	"./Icon_filter.svg": "./src/assets/svg/Icon_filter.svg",
	"./Icon_folder.svg": "./src/assets/svg/Icon_folder.svg",
	"./Icon_folder_button.svg": "./src/assets/svg/Icon_folder_button.svg",
	"./Icon_folder_hover.svg": "./src/assets/svg/Icon_folder_hover.svg",
	"./Icon_folder_tree.svg": "./src/assets/svg/Icon_folder_tree.svg",
	"./Icon_groups.svg": "./src/assets/svg/Icon_groups.svg",
	"./Icon_lang.svg": "./src/assets/svg/Icon_lang.svg",
	"./Icon_locked.svg": "./src/assets/svg/Icon_locked.svg",
	"./Icon_media.svg": "./src/assets/svg/Icon_media.svg",
	"./Icon_options.svg": "./src/assets/svg/Icon_options.svg",
	"./Icon_players.svg": "./src/assets/svg/Icon_players.svg",
	"./Icon_presentations.svg": "./src/assets/svg/Icon_presentations.svg",
	"./Icon_quickaccess.svg": "./src/assets/svg/Icon_quickaccess.svg",
	"./Icon_repeat.svg": "./src/assets/svg/Icon_repeat.svg",
	"./Icon_scheduler.svg": "./src/assets/svg/Icon_scheduler.svg",
	"./Icon_screenshot.svg": "./src/assets/svg/Icon_screenshot.svg",
	"./Icon_search.svg": "./src/assets/svg/Icon_search.svg",
	"./Icon_selectAll.svg": "./src/assets/svg/Icon_selectAll.svg",
	"./Icon_settings.svg": "./src/assets/svg/Icon_settings.svg",
	"./Icon_software.svg": "./src/assets/svg/Icon_software.svg",
	"./Icon_sort.svg": "./src/assets/svg/Icon_sort.svg",
	"./Icon_standardPresentation.svg": "./src/assets/svg/Icon_standardPresentation.svg",
	"./Icon_standardPresentationWhite.svg": "./src/assets/svg/Icon_standardPresentationWhite.svg",
	"./Icon_templates.svg": "./src/assets/svg/Icon_templates.svg",
	"./Icon_tests.svg": "./src/assets/svg/Icon_tests.svg",
	"./Icon_tests_white.svg": "./src/assets/svg/Icon_tests_white.svg",
	"./Icon_time.svg": "./src/assets/svg/Icon_time.svg",
	"./Icon_trash.svg": "./src/assets/svg/Icon_trash.svg",
	"./Icon_troubleshootingOptions.svg": "./src/assets/svg/Icon_troubleshootingOptions.svg",
	"./Icon_uncheckbox.svg": "./src/assets/svg/Icon_uncheckbox.svg",
	"./Icon_upload.svg": "./src/assets/svg/Icon_upload.svg",
	"./Icon_user.svg": "./src/assets/svg/Icon_user.svg",
	"./Icon_warning.svg": "./src/assets/svg/Icon_warning.svg",
	"./logo.svg": "./src/assets/svg/logo.svg",
	"./zoom.svg": "./src/assets/svg/zoom.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg sync recursive ^\\.\\/.*\\.svg$";